import React from "react";
import { Modal, Button } from "react-bootstrap";

interface DeleteFileModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteFileModal: React.FC<DeleteFileModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Izbriši datoteku</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Jeste li sigurni da želite izbrisati ovu datoteku?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Odustani
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Izbriši
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteFileModal;
